<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.3"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.1673 4.49846L2.82526 19.5125C2.74057 19.6648 2.69715 19.8365 2.69929 20.0108C2.70144 20.185 2.74909 20.3557 2.83751 20.5059C2.92593 20.656 3.05205 20.7805 3.20338 20.8669C3.35472 20.9533 3.526 20.9986 3.70026 20.9985H21.2173C21.3948 20.9984 21.5692 20.951 21.7223 20.8612C21.8755 20.7714 22.0021 20.6425 22.0889 20.4876C22.1758 20.3327 22.2198 20.1575 22.2165 19.98C22.2133 19.8025 22.1628 19.629 22.0703 19.4775L12.8943 4.46246C12.8031 4.3134 12.6744 4.19084 12.5211 4.107C12.3677 4.02315 12.1951 3.98095 12.0204 3.98459C11.8457 3.98823 11.675 4.03759 11.5253 4.12775C11.3756 4.21791 11.2522 4.34573 11.1673 4.49846Z"
      fill="#ECB53A"
    />
    <path
      d="M13 10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10V15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V10Z"
      fill="#ECB53A"
    />
    <path
      d="M13 18C13 17.4477 12.5523 17 12 17C11.4477 17 11 17.4477 11 18C11 18.5523 11.4477 19 12 19C12.5523 19 13 18.5523 13 18Z"
      fill="#ECB53A"
    />
  </svg>
</template>
